/* ZS: "Referred by" box (snippets/zs-referral) in the cart drawer and on /cart.
   1. Apply looks the code up with GoAffPro as a referral code and as a coupon code (ambassadors mostly share their
      coupon, e.g. RAYRAY15, whose referral code is different), then hands GoAffPro's loader the ambassador's
      referral code through its "goaffproReferralCode" event. The loader saves it in the "ref" cookie, as a link would.
   2. Copies it into the cart attributes GoAffPro reads from the order (__ref, __visit_id), which the loader otherwise
      only does on the next page load, so going straight from the drawer to checkout works; checkout waits for it.
   3. Ella re-renders the drawer on every cart change, so each new box is drawn from what was applied (localStorage),
      any half-typed code (sessionStorage) and whether it was open (sessionStorage).
   4. A shopper who arrived through a referral link sees that ambassador's coupon code as already added. */
(function () {
  if (window.zsReferral) return;
  window.zsReferral = true;

  var LOOKUP = 'https://api-server-3.goaffpro.com/v1/sdk/affiliate'; // the lookup GoAffPro's own widget uses
  var SHOP = 'zoosnoods.myshopify.com';
  var APPLIED_KEY = 'zs-ref-applied'; // {ref, code}: what the shopper entered and the referral code it maps to
  var DRAFT_KEY = 'zs-ref-draft';
  var OPEN_KEY = 'zs-ref-open';
  var pending = null;
  var lastRef;
  var queued = false;

  function store(kind, key, value) {
    try {
      var s = window[kind];
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (e) { return null; }
  }
  function getRef() {
    try { return typeof window.gfpGetCookie === 'function' ? window.gfpGetCookie('ref') || null : undefined; } catch (e) { return undefined; }
  }
  // What to show as applied, if GoAffPro still has it. A later ?ref= link (or expiry) replaces it, and then we forget it.
  // {none: true} marks a link referral GoAffPro doesn't recognise, so it isn't looked up again.
  function applied() {
    var a;
    try { a = JSON.parse(store('localStorage', APPLIED_KEY) || 'null'); } catch (e) { a = null; }
    if (!a || !a.ref) return null;
    var ref = getRef();
    if (ref === undefined) return a.none ? null : a; // loader not ready yet
    if (ref && ref.toLowerCase() === String(a.ref).toLowerCase()) return a.none ? null : a;
    store('localStorage', APPLIED_KEY, null);
    return null;
  }
  // Arrived through a referral link: GoAffPro already credits the ambassador, so show their coupon code
  // (what the shopper has seen in the ambassador's posts) as applied. Looked up once per referral.
  var resolving = null;
  function showLinkReferral() {
    var ref = getRef();
    if (!ref || ref === 'organic' || resolving === ref || store('localStorage', APPLIED_KEY)) return;
    resolving = ref;
    find('ref_code', ref, 'ref_code,coupon').then(function (j) {
      if (getRef() !== ref || store('localStorage', APPLIED_KEY)) return; // changed meanwhile
      store('localStorage', APPLIED_KEY, JSON.stringify(j ? { ref: ref, code: String(j.coupon || ref).toUpperCase() } : { ref: ref, none: true }));
      queue();
    }, function () { resolving = null; });
  }

  /* 1. Look the code up: as a referral code first, then as a coupon. Resolves {ref_code, ...} or null; rejects if GoAffPro can't be reached. */
  function find(param, code, fields) {
    var u = new URL(LOOKUP);
    u.searchParams.append(param, code);
    u.searchParams.append('fields', fields || 'ref_code');
    u.searchParams.append('x-shop', SHOP);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 6000) : null;
    return fetch(u.href, ctrl ? { signal: ctrl.signal } : {}).then(function (r) {
      clearTimeout(timer);
      return r.json();
    }).then(function (j) {
      if (j && j.ref_code) return j;
      if (j && j.error) return null;
      throw new Error('bad lookup');
    });
  }
  function lookup(code) {
    var asRef = find('ref_code', code), asCoupon = find('coupon', code);
    asCoupon.catch(function () {}); // may go unused
    return asRef.then(function (a) { return a || asCoupon; }, function () { return asCoupon; });
  }

  function apply(box) {
    var input = box.querySelector('[data-zs-ref-input]');
    var btn = box.querySelector('[data-zs-ref-apply]');
    var code = (input.value || '').trim();
    if (!code) { setError(box, 'Enter a code first.'); input.focus(); return; }
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Checking';
    setError(box, '');
    lookup(code).then(function (found) {
      if (!found) {
        setError(box, "We couldn't find that code. Check the spelling with your ambassador.");
        return;
      }
      give(found.ref_code, code);
    }, function () {
      // GoAffPro didn't answer: pass the code on as typed (GoAffPro matches it later if it's a referral code).
      give(code, code);
    }).then(function () {
      btn.disabled = false;
      btn.textContent = 'Apply';
    });
  }
  function give(ref, code) {
    store('localStorage', APPLIED_KEY, JSON.stringify({ ref: ref, code: code.toUpperCase() }));
    store('sessionStorage', DRAFT_KEY, null);
    window.dispatchEvent(new CustomEvent('goaffproReferralCode', { detail: { ref: ref } }));
    pass();
  }
  function remove() {
    store('localStorage', APPLIED_KEY, null);
    // GoAffPro's loader clears the cookie and the cart attributes for a null ref.
    window.dispatchEvent(new CustomEvent('goaffproReferralCode', { detail: { ref: null } }));
    pass();
  }
  function setError(box, msg) {
    var el = box.querySelector('[data-zs-ref-error]');
    if (el) el.textContent = msg;
    box.setAttribute('data-state', msg ? 'error' : (box.getAttribute('data-state') === 'applied' ? 'applied' : ''));
  }

  /* 2. Save the code on the cart (GoAffPro's addRefToCart reads the cookie). */
  function saveToCart() {
    if (typeof window.addRefToCart !== 'function') return;
    var p = Promise.resolve(window.addRefToCart()).catch(function () {}).then(function () { if (pending === p) pending = null; });
    pending = p;
  }
  lastRef = getRef();
  window.addEventListener('goaffproScriptLoaded', function () { if (lastRef === undefined) lastRef = getRef(); queue(); });
  window.addEventListener('goaffproReferralCode', function (e) {
    var ref = e && e.detail ? e.detail.ref : undefined;
    if (ref === undefined) return;
    var prev = lastRef;
    lastRef = ref || null;
    if (!ref) return;
    setTimeout(function () { // after GoAffPro's own listener has saved the cookie
      if (prev && prev !== ref) {
        // Switching from another ambassador (e.g. one whose link the shopper used): drop that visit, as
        // GoAffPro does when a new ?ref= link is opened, then log a visit for the new code.
        try {
          if (typeof window.gfp_remove_cookies === 'function') {
            window.gfp_remove_cookies([(window.__goaffpro && window.__goaffpro.source_cookie_name) || 'source', 'gfp_v_id']);
          }
          window.gfp_visit_tracked = false;
          if (typeof window.trackVisit === 'function') window.trackVisit();
        } catch (err) {}
      }
      saveToCart();
    }, 0);
  });
  // A new visit id arrives after GoAffPro logs the visit; save it on the cart too.
  window.addEventListener('goaffproVisitTracked', function () { if (getRef()) saveToCart(); });

  // Checkout waits (up to 2.5s) for the cart update.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#cart-sidebar-checkout, #cart-checkout') : null;
    if (!btn || !pending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.race([pending, new Promise(function (r) { setTimeout(r, 2500); })]).then(function () {
      pending = null;
      btn.click();
    });
  }, true);

  /* 3. Draw every box from saved state (new ones appear whenever Ella re-renders the drawer). */
  function pass() {
    queued = false;
    var boxes = document.querySelectorAll('[data-zs-ref]');
    if (!boxes.length) return;
    var a = applied();
    if (!a) showLinkReferral();
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (!box.hasAttribute('data-zs-ref-init')) {
        box.setAttribute('data-zs-ref-init', '');
        if (store('sessionStorage', OPEN_KEY) === '1') box.open = true;
        var draft = store('sessionStorage', DRAFT_KEY);
        if (draft) box.querySelector('[data-zs-ref-input]').value = draft;
      }
      if (a) {
        box.querySelector('[data-zs-ref-code]').textContent = a.code;
        if (box.getAttribute('data-state') !== 'applied') box.setAttribute('data-state', 'applied');
      } else if (box.getAttribute('data-state') === 'applied') {
        box.setAttribute('data-state', '');
      }
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(pass, 30); // not requestAnimationFrame: that pauses in background tabs
  }
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-zs-ref]') || n.querySelector('[data-zs-ref]'))) { queue(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var box = t.closest('[data-zs-ref]');
    if (!box) return;
    if (t.closest('[data-zs-ref-apply]')) { apply(box); return; }
    if (t.closest('[data-zs-ref-remove]')) {
      remove();
      setTimeout(function () { var i = box.querySelector('[data-zs-ref-input]'); if (i) i.focus(); }, 0);
      return;
    }
    if (t.closest('summary')) {
      // Opening it by hand puts the cursor in the field.
      setTimeout(function () {
        var i = box.open && box.getAttribute('data-state') !== 'applied' && box.querySelector('[data-zs-ref-input]');
        if (i) i.focus();
      }, 0);
    }
  });
  // Enter applies. preventDefault matters on /cart, where the box sits inside the cart form.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('[data-zs-ref-input]')) return;
    e.preventDefault();
    apply(e.target.closest('[data-zs-ref]'));
  });
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-zs-ref-input]')) return;
    store('sessionStorage', DRAFT_KEY, e.target.value || null);
    var box = e.target.closest('[data-zs-ref]');
    if (box.getAttribute('data-state') === 'error') setError(box, '');
  });
  // Remember open/closed so a drawer re-render doesn't snap the box shut.
  document.addEventListener('toggle', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-zs-ref]')) return;
    store('sessionStorage', OPEN_KEY, box.open ? '1' : '0');
  }, true);
})();
